import { motion } from 'framer-motion';
import { cn } from '../../lib/utils';
import { TrendingUp, TrendingDown } from 'lucide-react';

export function StatsCard({
  title,
  value,
  change,
  changeType = 'increase',
  icon: Icon,
  description,
  className,
  delay = 0,
  filterSlot,
  ...rest
}) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, delay }}
      className={cn(
        'bg-white dark:bg-slate-900',
        'group relative overflow-hidden rounded-2xl border border-slate-200/80 dark:border-slate-800',
        'p-6 shadow-soft hover:shadow-soft-lg hover:border-ae-blue/30',
        'transition-[box-shadow,border-color] duration-300',
        'h-full flex flex-col',
        className
      )}
      {...rest}
    >
      <div className="flex items-start justify-between">
        <div className="flex-1 min-w-0">
          <p className="text-[11px] font-semibold uppercase tracking-[0.12em] text-muted-foreground mb-2">
            {title}
          </p>
          <p className="text-2xl lg:text-3xl font-heading font-extrabold tracking-tight text-foreground truncate">
            {value}
          </p>
          {change && (
            <div className="flex items-center gap-1.5 mt-2">
              {changeType === 'increase' ? (
                <TrendingUp className="w-4 h-4 text-emerald-500" />
              ) : (
                <TrendingDown className="w-4 h-4 text-red-500" />
              )}
              <span
                className={cn(
                  'text-sm font-medium',
                  changeType === 'increase' ? 'text-emerald-500' : 'text-red-500'
                )}
              >
                {change}
              </span>
              {description && (
                <span className="text-sm text-muted-foreground">
                  {description}
                </span>
              )}
            </div>
          )}
          {!change && description && (
            <span className="text-sm text-muted-foreground">{description}</span>
          )}
          {filterSlot && <div className="mt-2">{filterSlot}</div>}
        </div>
        {Icon && (
          <div className="w-11 h-11 rounded-xl bg-ae-blue/10 dark:bg-ae-blue/20 ring-1 ring-ae-blue/15 flex items-center justify-center flex-shrink-0 transition-transform duration-300 group-hover:scale-110 group-hover:-rotate-3">
            <Icon className="w-5 h-5 text-ae-blue" />
          </div>
        )}
      </div>
    </motion.div>
  );
}
